interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  // If you also have optional fields like measurementId, add them here:
  measurementId?: string;
}

// 2. Create your actual config object
const firebaseConfig: FirebaseConfig = {
    apiKey: "AIzaSyAWcB40uqR3UKs8bx8bDABnVYXKBmW0rR8",
    authDomain: "lidap-9bd2e.firebaseapp.com",
    projectId: "lidap-9bd2e",
    storageBucket: "lidap-9bd2e.firebasestorage.app",
    messagingSenderId: "292261617205",
    appId: "1:292261617205:web:ecf5ed72f4bd35332fdb7c",
    measurementId: "G-8Q8BN88JL3"
};

// 3. Provide a getter function that throws an error if no config is found
export function getFirebaseConfig(): FirebaseConfig {
  if (!firebaseConfig || !firebaseConfig.apiKey) {
    throw new Error(
      'No Firebase configuration object provided.\n' +
        'Add your web app’s configuration object to firebaseConfig.ts'
    );
  }
  return firebaseConfig;
}
